import React from 'react';

/** Split on whitespace into token spans so cells wrap on spaces and long words can ellipsize. */
export const renderWrappedText = (text: string, tokenClassName: string): React.ReactNode =>
  text.split(/(\s+)/).map((part, partIndex) =>
    /^\s+$/.test(part) ? (
      <React.Fragment key={`s-${partIndex}`}>{part}</React.Fragment>
    ) : (
      <span key={`w-${partIndex}`} className={tokenClassName}>
        {part}
      </span>
    )
  );
